import { useEffect, useRef } from "react";

export const useIsUnmounted = () => {
    const isUnmountedRef = useRef(false);
    useEffect(() => () => void (isUnmountedRef.current = true), []);
    return { isUnmountedRef };
}